export default {
  SET_DRAFTS (state, drafts) {
    state.drafts = drafts
  },
  SET_DRAFT (state, draft) {
    state.drafts.unshift(draft)
  },
  SET_LATEST_UPDATED_DRAFT (state, draft) {
    state.lastUpdatedDraft = draft
  },
  UPDATE_DRAFT (state, draft) {
    const { antraegeEntwuerfeId: draftId } = draft
    const index = state.drafts.findIndex((e) => e.antraegeEntwuerfeId === draftId)
    if (index !== -1) {
      Object.assign(state.drafts[index], draft)
    }
  },
  DELETE_DRAFT (state, draftId) {
    const index = state.drafts.findIndex((e) => e.antraegeEntwuerfeId === draftId)
    if (index !== -1) {
      state.drafts.splice(index, 1)
    }
  },
  SET_PAGE_INDEX (state, value) {
    state.pageIndex = value
  }
}
